export interface Tip {
  title: string;
  description: string;
}

export interface ReportingMethod {
  title: string;
  icon: string;
  items?: string[];
  description?: string;
  link_text?: string;
  link_url?: string;
}

export interface Stat {
  label: string;
  value?: string;
  value_type?: string;
}

export interface BetaStatusContent {
  title: string;
  subtitle: string;
  tips_header: string;
  reporting_header: string;
  tips: Tip[];
  reporting: ReportingMethod[];
  stats: Stat[];
  visible: boolean;
}

export const DEFAULT_CONTENT: BetaStatusContent = {
  title: 'Beta Testing Guide',
  subtitle: 'Essential tips for effective testing and feedback',
  tips_header: 'Testing Best Practices',
  reporting_header: 'How to Report Issues',
  tips: [],
  reporting: [],
  stats: [],
  visible: true,
};
